import { createRouter, createWebHistory } from 'vue-router'
import { app } from '../main';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/change-password',
    name: 'Change Password',
    component: () => import('../views/ChangePassword.vue')
  },
  {
    path: '/admin-dashboard',
    name: 'Admin Dashboard',
    component: () => import('../views/AdminDashboard.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// eslint-disable-next-line 
router.beforeEach((to, from) => {
  if (!['/login', '/change-password'].includes(to.path)) {
    const apiInstance = app.config.globalProperties.api;
    if (!apiInstance.token && to.name !== 'Login') {
      return { name: 'Login' }
    } else {
      if (apiInstance.role == 'vad') {
        if (to.path !== '/dashboard') {
          return { name: 'Dashboard' }
        }
      } else {
        if (to.path !== '/admin-dashboard') {
          return { name: 'Admin Dashboard' }
        }
      }
    }
  }
})

export default router
